import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 25"
}, n = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.251 10V4a3 3 0 0 0-3-3h-8.25a3 3 0 0 0-3 3v16.5a3 3 0 0 0 3 3h6"
}, null, -1), s = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M22 18.25A5.25 5.25 0 1 1 16.75 13"
}, null, -1), l = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m22 14.312-4.785 4.786a.66.66 0 0 1-.929 0l-1.5-1.5M1 19.75h7.501m-.247-12.6a1.575 1.575 0 1 0 0-3.15 1.575 1.575 0 0 0 0 3.15m2.759 3.545a2.756 2.756 0 1 0-5.513 0v1.181h1.182l.393 3.938h2.363l.394-3.938h1.18z"
}, null, -1), c = [
  n,
  s,
  l
];
function d(i, h) {
  return e(), t("svg", r, [...c]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
